module.exports = __webpack_public_path__ + "static/media/no_box_office.36a20dfc.png";